import React from 'react';
import Jobs from './Jobs';
import Workers from './Workers';

const Optimizer = () => {
  return (
    <div className="grid grid-cols-7 gap-4">
      <div className="col-start-2 col-span-5">
        <Workers />
      </div>
      <div className="col-start-2 col-span-5">
        <Jobs />
      </div>
    </div>
  );
};

export default Optimizer;
